const PREFIX = 'fair_decl_v1_';
const TTL_MS = 5 * 60 * 1000;

async function hashToken(token) {
  if (!token) return null;
  try {
    const buf = new TextEncoder().encode(token);
    const digest = await crypto.subtle.digest('SHA-256', buf);
    return Array.from(new Uint8Array(digest)).slice(0, 8).map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    let h = 0;
    for (let i = 0; i < token.length; i += 1) h = ((h << 5) - h + token.charCodeAt(i)) | 0;
    return Math.abs(h).toString(16);
  }
}

function stripTemplates(data) {
  if (!data) return data;
  const { templates, bccRoutingAddress, ...safe } = data;
  const lenders = (safe.lenders || []).map(({ agreementNumber, lenderEmail, ...rest }) => rest);
  return { ...safe, lenders };
}

export async function readCache(token) {
  try {
    const key = PREFIX + (await hashToken(token));
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry || (Date.now() - entry.cachedAt) > TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return entry.value;
  } catch {
    return null;
  }
}

export async function writeCache(token, data) {
  try {
    const key = PREFIX + (await hashToken(token));
    localStorage.setItem(key, JSON.stringify({ cachedAt: Date.now(), value: stripTemplates(data) }));
  } catch {}
}

export async function clearCache(token) {
  try {
    const key = PREFIX + (await hashToken(token));
    localStorage.removeItem(key);
  } catch {}
}
